import { FC } from 'react';

import { SegmentedProgressBar } from '@hh.ru/magritte-ui-progress-bar/SegmentedProgressBar';
import { SingleProgressBar } from '@hh.ru/magritte-ui-progress-bar/SingleProgressBar';
import { ProgressBarSkeleton } from '@hh.ru/magritte-ui-progress-bar/Skeleton';
import { ProgressBarProps } from '@hh.ru/magritte-ui-progress-bar/types';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';

export const ProgressBarComponent: FC<ProgressBarProps> = (props) => {
    const isSegmented = props.segments !== undefined;
    return isSegmented ? <SegmentedProgressBar {...props} /> : <SingleProgressBar {...props} />;
};

export const ProgressBar = enrichWithSkeleton(ProgressBarComponent, ProgressBarSkeleton);
